import React from "react"
import cx from "classnames"

type Props = {
  className?: string
  children: JSX.Element | JSX.Element[]
}

const GridCol3 = ({ children, className }: Props) => {
  return (
    <div
      className={cx(
        "grid",
        "grid-cols-1",
        "sm:grid-cols-3",
        "gap-3",
        className
      )}
    >
      {children}
    </div>
  )
}

export default GridCol3
